import React from 'react';
import Button from '../../forms/Button';
import { generateId, shortHandDate } from '../../utility/functions';
import LinkTo from '../../forms/LinkTo';
import Table from '../../table/Table';
import ManageOrder from './ManageOrder';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';
import Input from '../../forms/Input';
import Form from '../../forms/Form';
import GetState from '../../GetState';
import ModalFactory from '../../Modal';

const FulfilledOrders = ({ ...props }) => {

    const [orders, refreshOrders] = GetState(QuestRoute.fulfillment.orders, {
        callback: e => {
            e.productsList = e.products.map(f => f.name).join(',')
        }
    });

    const completeOrder = (modalId, order) => {
        const id = generateId();

        if (order.products.find(e => e.appProductType === 'GiftCard')) {
            ModalFactory.show({
                id,
                title: 'Activate and Complete Order',
                body: (
                    <Form
                        inputs={{
                            cardNumber: ''
                        }}
                        onSubmit={e => HamQuest.put(QuestRoute.fulfillment.editOrder(order.orderId), {
                            orderId: order.orderId,
                            ...e
                        })
                            .then(() => {
                                refreshOrders();
                                ModalFactory.close(modalId, id);
                            })}
                    >
                        <Input
                            label='Card Number'
                            name='cardNumber'
                            type='number'
                            required
                        />
                    </Form>
                )
            })
        } else {
            HamQuest.put(QuestRoute.fulfillment.editOrder(order.orderId), {
                orderId: order.orderId
            })
                .then(() => {
                    refreshOrders();
                    ModalFactory.close(modalId);
                })
                .catch(ModalFactory.catch)
        }
    }

    const manage = (order) => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Manage Order`,
            // buttons: [<Button onClick={() => completeOrder(order)}>{order.completed ? 'Undo' : 'Complete'} Order</Button>, <Button>Print Order</Button>],
            buttons: [<Button onClick={() => completeOrder(id, order)}>{order.completed ? 'Undo' : 'Complete'} Order</Button>],
            body: <ManageOrder refresh={refreshOrders} {...order} />
        })
    }

    return (
        <Table
            config={{
                // label: 'Orders',
                colSpacing: [10, 10, 15, 30, 15, 10, 10],
                data: orders?.filter(e => e.completed),
                headers: [
                    {
                        label: 'Order',
                        propKey: 'orderId',
                    }, {
                        label: 'Invoice',
                        propKey: 'invoiceId',
                    }, {
                        label: 'Customer',
                        propKey: 'customerName',
                    }, {
                        label: 'Address',
                        propKey: 'address',
                    }, {
                        label: 'Products',
                        propKey: 'productsList',
                    }, {
                        label: 'Ordered',
                        propKey: 'orderDate',
                        type: 'date'
                    }, {
                        label: 'Completed Date',
                        propKey: 'completedDate',
                        type: 'date'
                    },
                ],
                renderFormat: (e) => (
                    <tr key={generateId()}>
                        <td><Button onClick={() => manage(e)}>{e.orderId}</Button></td>
                        <td><LinkTo target='_blank' to={'/reporting/Sales/Invoice/' + e.invoiceId}>{e.invoiceId}</LinkTo></td>
                        <td>{e.customerName}</td>
                        <td>{e.address}</td>
                        <td>{e.products.map(f => `${f.name} (x${f.quantity})`)}</td>
                        <td>{shortHandDate(e.orderDate)}</td>
                        <td>{shortHandDate(e.completedDate)}</td>
                    </tr>
                )
            }}
        />
    );
}

export default FulfilledOrders;
